(function () {
  'use strict';

  class ConfirmExpurgoModalCtrl {
    constructor($uibModalInstance, evento) {
      this.modalInstance = $uibModalInstance;
      this.evento = evento;
    }

    confirmar() {
      this.modalInstance.close();
    }

    cancel() {
      this.modalInstance.dismiss();
    }
  }

  angular
    .module('expurgo')
    .controller('ConfirmExpurgoModalCtrl', ConfirmExpurgoModalCtrl);
}());

